import React from "react";
import {
  FormGroup,
  Alert,
  Spinner,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import Select from "react-select";
import { useStepperContext } from "../../../../Stepper/StepperContext";

const WorkOrderSelectionStep = ({
  destinationWorkOrders = [],
  onSelectWorkOrder,
}) => {
  const { updateStepData } = useStepperContext();

  if (!destinationWorkOrders || destinationWorkOrders.length === 0) {
    return (
      <div className="py-4">
        {!destinationWorkOrders ? (
          <div className="text-center">
            <Spinner color="primary" />
            <p className="mt-2">Loading available work orders...</p>
          </div>
        ) : (
          <Alert color="warning" className="p-3 m-3">
            No destination work orders available for this crane inspection.
          </Alert>
        )}
      </div>
    );
  }

  const workOrderOptions = destinationWorkOrders.map((wo) => ({
    value: wo.id,
    label: `${wo.jobNo} - ${wo.customer.name}`,
    workOrder: wo,
  }));

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff"
        : state.isFocused
        ? "#e9ecef"
        : "white",
      color: state.isSelected ? "white" : "#333",
      padding: "10px 15px",
    }),
    control: (provided) => ({
      ...provided,
      border: "1px solid #ced4da",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #80bdff",
      },
    }),
  };

  const handleWorkOrderChange = (selectedOption) => {
    updateStepData("selectedWorkOrder", selectedOption?.workOrder || null);
    if (onSelectWorkOrder) {
      onSelectWorkOrder(selectedOption?.workOrder || null);
    }
  };

  return (
    <div className="p-4">
      <Row>
        <Col>
          <Card className="mb-4">
            <CardHeader className="bg-light">
              <h6 className="mb-0">Select a Work Order</h6>
            </CardHeader>
            <CardBody>
              <FormGroup>
                <Select
                  id="workOrderSelect"
                  options={workOrderOptions}
                  placeholder="Select a destination work order..."
                  className="basic-single"
                  classNamePrefix="select"
                  onChange={handleWorkOrderChange}
                  styles={customStyles}
                  isSearchable={true}
                />
              </FormGroup>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default WorkOrderSelectionStep;
